import React from 'react'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import Icons from '~/Common-Objects/UI/Icons/index'
import i18n from '~/i18n'
import CreateTemplateSplash from '~/Common-Objects/Onboarding/splashes/create-template.png'
import { OnboardingStep } from '~/Common-Objects/Onboarding'

export default function TemplateStep({ isOpen, isComplete, onClick, onCreateTemplate, postHogTag }) {
    return (
        <OnboardingStep
            key='template'
            title={i18n.t('setup:steps.create-template.title')}
            icon={<Icons icon='templateOutline' color='currentColor' />}
            isOpen={isOpen}
            isComplete={isComplete}
            onClick={onClick}
        >
            <p>{i18n.t('setup:steps.create-template.content')}</p>
            <div>
                <Button
                    className='button-primary button-small'
                    iconRight={<Icons icon='arrowRight' />}
                    onClick={(e) => {
                        e.stopPropagation()
                        onCreateTemplate()
                    }}
                    postHogTag={postHogTag}
                >
                    {i18n.t('setup:steps.create-template.button-text')}
                </Button>
            </div>
        </OnboardingStep>
    )
}

TemplateStep.splash = <img src={CreateTemplateSplash} alt={i18n.t('setup:steps.create-template.title')} />
